import React from "react";

import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
import { defaultRequest } from "../../utils/request/request";

// Icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

// Images
import logo from "../../data/logo.png";
import bg from "../../data/bg.png";

class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showAlert: false,
            alertMessage: '',
            alertType: null,
            email: '',
            password: '',
            showPassword: false,
            isDisabled: false,
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.id]: event.target.value,
        })
    }

    handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            this.logIn()
        }
    }

    logIn = () => {
        // REQUEST PARA VALIDAÇÃO DE DADOS
        this.setState({ isDisabled: true })

        let config = {
            method: 'get',
            endpoint: 'login'
        }

        let form = {
            email: this.state.email,
            password: this.state.password
        }

        defaultRequest(config, form).then((r) => {
            if (r.status) {
                localStorage.setItem('userToken', r.data.token)
                window.location.href = '/#/'
                window.location.reload()
                this.setState({ isDisabled: false })
            } else {
                this.setState({ showAlert: true, alertType: 'error', alertMessage: r.data.message, isDisabled: false })
            }
        })
    }

    render() {
        return (
            <Box
                display='grid'
                height='100vh'
                width='100vw'
                sx={{
                    backgroundImage: `url(${bg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top center',
                    backgroundRepeat: 'no-repeat'
                }}
            >

                <Box sx={{ margin: 'auto' }}>

                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',

                        backgroundColor: 'white',
                        borderRadius: '20px',
                        padding: '30px 30px 10px 30px'
                    }}>

                        <Box component="img" src={logo} sx={{
                            width: '80%',
                            height: 'auto',
                            margin: 'auto',
                            marginBottom: '15px',
                            objectFit: 'contain',
                            backgroundPosition: 'top center',
                        }} />

                        <Typography sx={{ fontSize: '22px', fontWeight: 'bold', color: this.props.colors.blueAccent[100], margin: '0 auto' }}>EverSales BackOffice</Typography>
                        <Typography sx={{ fontSize: '15px', fontWeight: '500', color: this.props.colors.blueAccent[100], margin: '0 auto' }}>Gestão de Força de Vendas</Typography>

                        <Typography sx={{ fontSize: '13px', fontWeight: '200', color: this.props.colors.grey[800], margin: '20px auto 0 auto' }}>Utilize o mesmo acesso usado no ERP EVEREST</Typography>

                        <Box mb='20px'>
                            <TextField
                                id='email'
                                value={this.state.email}
                                onChange={(event) => this.handleChange(event)}
                                placeholder='E-mail...'
                                size='small'
                                fullWidth
                                onKeyUp={this.handleKeyUp}
                                sx={{
                                    '& .MuiInputBase-root': {
                                        borderRadius: '12px',
                                    },
                                    borderRadius: '12px',
                                    backgroundColor: '#F7F7F7',
                                    '& fieldset': {
                                        borderRadius: '12px',
                                        border: '2px solid #E5E5E5',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: 'none !important'
                                    }
                                }}
                            />
                        </Box>
                        <Box mb='20px'>
                            <TextField
                                id='password'
                                type={this.state.showPassword ? 'text' : 'password'}
                                value={this.state.password}
                                onChange={(event) => this.handleChange(event)}
                                placeholder='Senha...'
                                size='small'
                                fullWidth
                                onKeyUp={this.handleKeyUp}
                                sx={{
                                    borderRadius: '12px',
                                    backgroundColor: '#F7F7F7',
                                    '& .MuiInputBase-root': {
                                        borderRadius: '12px',
                                    },
                                    '& fieldset': {
                                        borderRadius: '12px',
                                        border: '2px solid #E5E5E5'
                                    },
                                    '&:hover fieldset': {
                                        borderColor: 'none !important'
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start" onClick={() => this.setState({ showPassword: !this.state.showPassword })} sx={{ 'cursor': 'pointer' }}>
                                            {this.state.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        {this.state.showAlert ?
                            <Box mb='20px' textAlign='center'>
                                <Typography color='#cf1508'>{this.state.alertMessage}</Typography>
                            </Box>
                            : <></>}
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Button
                                sx={{
                                    width: '100%',
                                    color: 'white',
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    backgroundColor: this.props.colors.blueAccent[100],
                                    ':hover': { backgroundColor: this.props.colors.blueAccent[200] },
                                    ':disabled': { background: this.props.colors.blueAccent[300], color: 'white' }
                                }}
                                onClick={this.logIn}
                                disabled={this.state.isDisabled}
                            >
                                Acessar
                            </Button>
                        </Box>

                        <Typography sx={{ fontSize: '13px', margin: '20px auto', textDecoration: 'underline' }}>v 0.00</Typography>
                        <Typography sx={{ fontSize: '13px', margin: 'auto' }}>Desenvolvido por ACOM Sistemas</Typography>
                    </Box>

                </Box>
            </Box>
        )
    }
}

export default Login